import * as React from "react";
const QuotesImageMobile = (props) => (
    <svg
    width={88}
    height={39}
    viewBox="0 0 88 39"
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M35.0184 0.0411078C25.1198 0.011625 10.7722 -0.0173501 3.83896 0.0126665C1.68958 0.0219719 0 1.75367 0 3.90308V15.5266C0 17.7358 1.79086 19.5266 4 19.5266H15.5C17.7091 19.5266 19.5 21.3175 19.5 23.5266V35C19.5 37.2091 21.2909 39 23.5 39H35C37.2091 39 39 37.2091 39 35V4.0402C39 1.83636 37.2222 0.0476719 35.0184 0.0411078Z"
      fill={props.color}
    />
    <path
      d="M84.0184 0.0411078C74.1198 0.011625 59.7722 -0.0173501 52.839 0.0126665C50.6896 0.0219719 49 1.75367 49 3.90308V15.5266C49 17.7358 50.7909 19.5266 53 19.5266H64.5C66.7091 19.5266 68.5 21.3175 68.5 23.5266V35C68.5 37.2091 70.2909 39 72.5 39H84C86.2091 39 88 37.2091 88 35V4.0402C88 1.83636 86.2222 0.0476719 84.0184 0.0411078Z"
      fill={props.color}
    />
  </svg>
);
export default QuotesImageMobile;